<ion-header mode="ios">
  <ion-toolbar>
    <super-back-button slot="start" [modalController]="modalController"></super-back-button>
    <ion-title>{{id?.sid?.name}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>


  @if (!documentData) {
  <div class="p-4">
    <ion-skeleton-text class="w-full h-[180px] rounded-xl overflow-hidden" [animated]="true"></ion-skeleton-text>
  </div>
  }

  @if (documentData) {
  <div class="w-full">

    @if (!(isOwnerView$ | async)) {
    <div class="p-4">
      @if (!documentAccess) {
      <ion-skeleton-text class="w-full h-20 rounded-xl overflow-hidden"></ion-skeleton-text>
      }
      @if (documentAccess) {
      <div class="flex flex-row justify-between items-center gap-2.5 p-4 rounded-xl overflow-hidden bg-white">
        <avatar-round [autoBase]="false" [size]="50" [imageUrl]="ownerImage"
          [title]="documentAccess?.documentOwnerAccount?.name"></avatar-round>
        <div class="flex-1 min-w-0 flex flex-col gap-1">
          <p class="m-0 text-lg text-shade-three">{{documentAccess?.documentOwnerAccount?.name}}</p>
          @if (documentAccess?.documentOwnerAccount?.email?.length > 0) {
          <p class="m-0 text-sm text-shade-two flex flex-row items-center gap-1">
            <ion-icon name="mail-outline"></ion-icon>{{documentAccess?.documentOwnerAccount?.email}}
          </p>
          }
          @if (documentAccess?.documentOwnerAccount?.phoneNumber?.length > 0) {
          <div class="m-0 text-sm text-shade-two flex flex-row items-center gap-1">
            <ion-icon name="call-outline"></ion-icon>{{documentAccess?.documentOwnerAccount?.phoneNumber | formatPhone}}
          </div>
          }
        </div>
      </div>
      }
    </div>
    }

    @if (documentData?.verifyTime || id?.verificationTime) {
    <div #sidMockupContainer>
      <sid-view [id]="id" [documentData]="documentData"></sid-view>
    </div>
    <div class="px-4 flex flex-row justify-end">
      <div class="rounded-[25px] bg-ocean-200 p-2 flex flex-row gap-2.5">
        <ion-icon (click)='shareMockup($event)'
          class="size-5 rounded-full bg-white p-1 cursor-pointer box-content"
          name='share-social-outline'></ion-icon>
        <ion-icon (click)="saveMockupToLocal($event)"
          class="size-5 rounded-full bg-white p-1 cursor-pointer box-content"
          name="download-outline"></ion-icon>
      </div>
    </div>
    }

    @if (documentData && !(documentData?.verifyTime || id?.verificationTime)) {
    <div class="p-4 flex flex-col gap-2.5">
      @for (image of documentData?.scannedImages; track image; let i = $index) {
      <div class="flex flex-row items-end justify-end w-full h-[200px] rounded-[15px] bg-cover bg-center shadow-[0_5px_10px_rgba(0,0,0,0.1)] p-4"
        [style.backgroundImage]="'url(' + getImage(image.imageUrl) + ')'"
        (click)="viewPhoto(documentData?.scannedImages, i)">

        <div class="rounded-[25px] bg-ocean-200 p-2 flex flex-row gap-2.5">
          <ion-icon (click)='share($event,image)'
            class="size-5 rounded-full bg-white p-1 cursor-pointer box-content"
            name='share-social-outline'></ion-icon>
          <ion-icon (click)="shareToLocal($event,image)"
            class="size-5 rounded-full bg-white p-1 cursor-pointer box-content"
            name="download-outline"></ion-icon>
        </div>
      </div>
      }
    </div>
    }

    <div class="p-4 flex flex-col items-stretch gap-2.5">
      @if (documentData.idNumber) {
      <div class="flex flex-col rounded-md overflow-hidden py-2.5 px-4 bg-white gap-1.5">
        <p class="text-left m-0 text-xs">{{id?.sid?.name ?? 'Document'}} Number</p>
        <h3 class="m-0 text-lg">{{documentData?.idNumber}}</h3>
      </div>
      }

      @if (accessRemark) {
      <div class="flex flex-col rounded-md overflow-hidden py-2.5 px-4 bg-white gap-1.5">
        <p class="text-left m-0 text-xs">Remark</p>
        <h3 class="m-0 text-lg">{{accessRemark}}</h3>
      </div>
      }

      @if (documentData?.manualFields && documentData?.manualFields?.length > 0) {
      <div class="flex flex-col items-stretch bg-white rounded-md overflow-hidden">

        @for (field of documentData.manualFields; track field) {
        <div class="flex flex-col border-b border-shade-one py-2.5 px-4 gap-1.5">
          <p class="text-left m-0 text-xs">{{field.label}}</p>
          <h3 class="m-0 text-lg">{{field.value}}</h3>
        </div>
        }
      </div>
      }
    </div>

    @if (isOwnerView$ | async) {
    <div class="p-4 flex flex-col gap-2.5">

      @if (sharedToAccounts?.length > 0) {
      <div>
        <h1 class="text-lg m-0 mx-2.5 mb-2.5">Shared with</h1>
        <div class="rounded-md overflow-hidden bg-white">
          @for (account of (sharedWithExpanded ? sharedToAccounts : sharedToAccounts.slice(0, sharedWithPreviewCount)); track account) {
          <ion-list>
            <ion-item>
              <avatar-round slot="start" [size]="25" [title]="account?.name"
                [imageUrl]="account?.displayPictureUrl"></avatar-round>
              <ion-label>{{account?.name}}</ion-label>
            </ion-item>
          </ion-list>
          }
          <div class="p-4 flex flex-row justify-start">
            @if (sharedToAccounts.length > sharedWithPreviewCount) {
              <button
                type="button"
                (click)="sharedWithExpanded = !sharedWithExpanded"
                class="bg-transparent border-0 p-0 mt-2 text-sm text-gray-600 cursor-pointer text-left">
                <span class="text-black text-base">
                  {{ sharedWithExpanded ? 'Show less' : 'Show more (' + (sharedToAccounts.length - sharedWithPreviewCount) + ')' }}
                </span>
              </button>
              }
          </div>
        </div>

      </div>
      }

      <div class="flex flex-col rounded-md overflow-hidden py-2.5 px-4 bg-white gap-1.5">
        <p class="text-left m-0 text-xs">Created on</p>
        <h3 class="m-0 text-lg">{{id?.createTime | date : 'medium'}}</h3>
      </div>

      @if ((activeAccount$ | async)?._id == id?.account_id) {
      <button
        type="button"
        (click)="updateDocumentClicked()"
        class="bg-transparent border-0 p-4 m-0 cursor-pointer text-left">

        <ion-icon
          name="create-outline"
          class="align-middle me-1.5 text-[1.3em]"></ion-icon>
        <span class="underline text-black text-base align-middle">
          Update Id
        </span>
      </button>
      }


    </div>
    }

    @if (documentAccess?.apiAccessRemarks?.length > 0) {
    <div class="flex flex-col gap-2.5 p-4">
      <h1 class="text-lg m-0 mx-2.5 text-shade-two">Access History</h1>
      @for (apiAccessRemark of documentAccess.apiAccessRemarks; track apiAccessRemark) {
      <div class="flex flex-row justify-between items-center bg-white rounded-xl overflow-hidden p-4">
        <div class="flex flex-col gap-1.5">
          <p class="m-0 text-sm text-shade-two">Remark</p>
          <p class="m-0">{{apiAccessRemark.remark}}</p>
        </div>
        <p class="m-0 text-sm text-shade-two">{{apiAccessRemark.time | date : 'short'}}</p>
      </div>
      }
    </div>
    }
  </div>

  }

  <div class="h-10"></div>

</ion-content>
